export const ALLOWED_ORIGINS_FOR_UNTRAINED_MESSAGE = [
  "http://localhost:3010",
  "https://bot.writesonic.com",
  "https://botsonic.dev",
];
